import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentStatusPage = {
  alert: {
    error: 'applicant-employment-status-page.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-status-page.footer.root',
  },
  form: {
    h1: 'applicant-employment-status-page.form.h1',
    h2: 'applicant-employment-status-page.form.h2',
    radioGroupRoot: 'applicant-employment-status-page.form.radio-group-root',
    radioOption1: 'applicant-employment-status-page.form.radio-option-1',
    radioOption2: 'applicant-employment-status-page.form.radio-option-2',
    root: 'applicant-employment-status-page.form.root',
    submitButton: 'applicant-employment-status-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
